import ContentScroller from '@components/utils/scroller/ContentScroller';
import {
    ModuleFragment,
    ContentStoryFragment,
} from '@graphql/generated/graphql';
import { useRouter } from 'next/router';

import StoryPreview from './storyPreview';

type PropsType = {
    module: ModuleFragment;
    searchQuery?: string;
};

const StoriesSection = ({ module, searchQuery }: PropsType) => {
    const router = useRouter();

    if (!module.Module) throw Error('No content received in Story module');

    const stories = [...(module.Module.Content as ContentStoryFragment[])];

    return (
        <ContentScroller module={module}>
            {stories.map(({ Story }, index, array) => (
                <StoryPreview
                    key={Story!.id}
                    story={Story!}
                    context={{
                        module: module.Module!.id,
                        fromPage: router.pathname.includes('search')
                            ? 'search'
                            : '',
                        searchQuery,
                    }}
                    id={index}
                    storyLength={array.length}
                />
            ))}
        </ContentScroller>
    );
};

export default StoriesSection;
